import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class FieldViewModel {
  data;
  checked = false;

  constructor(data, report) {
    makeAutoObservable(this);

    this.data = data;

    const existingField = _.find(report.columns, {key: data.key});
    if (existingField) {
      this.data.merge(existingField);
      this.checked = true;
    }
  }

  toggleChecked() {
    this.checked = !this.checked;
  }
}

export default FieldViewModel;
